import React from 'react';
import { useIntl } from 'react-intl';

import { TenantIcon, EmployeeIcon, VendorIcon } from "utilities/iconsNew";

const AddUserType = ({ updateForm, onNext, facility }) => {
  const intl = useIntl();
  const types = [
    ...(facility?.pms === "" ? [{
      id: "add-user-type-tenant",
      name: "tenant",
      title: 'Tenant',
      icon: <TenantIcon />,
      text: intl.formatMessage({ id: "pages.users.create.tenant.desc" }),
    }] : []),
    {
      id: "add-user-type-employee",
      name: "employee",
      title: 'Employee',
      icon: <EmployeeIcon />,
      text: intl.formatMessage({ id: "pages.users.create.employee.desc" }),
    },
    {
      id: "add-user-type-limited",
      name: "limited",
      title: 'Service/Vendor',
      icon: <VendorIcon />,
      text: intl.formatMessage({ id: "comp.simple.userCreate" }),
    },
  ];
  return (
    <div className={`${types.length === 2 ? "grid grid-cols-2 gap-6 py-6 px-18" : "grid grid-cols-3 gap-4 p-6"}`}>
      {types.map((type) => (
        <button
          id={type.id}
          data-cy={type.id}
          key={type.name}
          className="p-5 flex flex-col items-center border border-[var(--color-gray-100)] rounded-[16px]"
          onClick={() => {
            updateForm("userType")(type.name);
            onNext();
          }}
        >
          {type.icon}
          <h5 className="pt-6 pb-2 tw-heading-5 text-[var(--color-blue-600)]">{type.title}</h5>
          <p className="tw-paragraph-reg text-[var(--color-gray-400)]">{type.text}</p>
        </button>
      ))}
    </div>
  )
}

export default AddUserType;